import { render, staticRenderFns } from "./EyeContactSlider.vue?vue&type=template&id=6350c802&scoped=true&"
import script from "./EyeContactSlider.vue?vue&type=script&lang=js&"
export * from "./EyeContactSlider.vue?vue&type=script&lang=js&"
import style0 from "./EyeContactSlider.vue?vue&type=style&index=0&id=6350c802&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6350c802",
  null
  
)

export default component.exports